import React, { useState } from "react";
import { ArrowRightIcon } from "lucide-react";
import { btnLight, container } from "../../utils/styles";
import { RequestModal } from "../RequestModal";
const examples = ["Naamborden", "Logo's", "Huisnummers", "Bedrijfscadeaus"];
export function CustomBand() {
  const [open, setOpen] = useState(false);
  return <section id="maatwerk" aria-labelledby="custom-heading" className="scroll-mt-24 bg-paper pb-16 lg:pb-24" data-id="element-141" data-mp="3co7z7ibnmnkv">
      <div className={container} data-id="element-142" data-mp="37qy3jkxo9fol">
        <div className="flex flex-col gap-8 rounded-xl bg-gold-deep px-6 py-12 text-paper sm:px-12 lg:flex-row lg:items-center lg:justify-between lg:px-16 lg:py-16" data-id="element-143" data-mp="32z6krwkrce90">
          <div className="max-w-2xl" data-id="element-144" data-mp="2yxl40053rftj">
            <h2 id="custom-heading" className="text-3xl font-medium tracking-[-0.03em] lg:text-5xl lg:leading-[1.05]" data-id="element-145" data-mp="2tyi2uqs8ttqu">
              Een eigen idee? Wij maken het op maat.
            </h2>
            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-146" data-mp="2k02hl4fwdep9">
              {examples.map(e => <li key={e} className="rounded-full bg-paper/15 px-3 py-1.5 text-sm text-paper" data-id="element-147" data-mp="3lkmirz5vi90d">
                  {e}
                </li>)}
            </ul>
          </div>
          <button type="button" onClick={() => setOpen(true)} className={`${btnLight} h-14 shrink-0 px-8`} data-id="element-148" data-mp="3qd5v6sstqy3l">
            Vertel ons je idee <ArrowRightIcon className="h-4 w-4" data-id="element-149" data-mp="3gl02thynuenv" />
          </button>
        </div>
      </div>
      <RequestModal open={open} onClose={() => setOpen(false)} data-id="element-150" data-mp="85zm1k4vesfg" />
    </section>;
}